import React from 'react';

const SuccessMessage: React.FC = () => {
  return (
    <div className="success-message">
      <div className="success-content">
        <div className="success-icon">
          <svg 
            width="64" 
            height="64" 
            viewBox="0 0 24 24" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="10" fill="#10B981" />
            <path 
              d="M9 12l2 2 4-4" 
              stroke="white" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <h2 className="success-title">Your request has been submitted</h2>
        <p className="success-description">
          Thank you for contacting us. Our support team will review your request and get back to you soon.
        </p>
      </div>
    </div>
  );
};

export default SuccessMessage;
